module.exports = __webpack_public_path__ + "static/media/item6.f5fd97b5.jpg";